import React, { useEffect, useState } from 'react';
import { ChatViewport } from '@/components/chat-viewport/';
import { HeaderChat } from '@/components/header-chat';
import { useGetChat } from '@/hooks/use-get-chat';
import { useGetSettings } from '@/hooks/use-get-settings';
import { useCurrentChatInfo } from '@/store/useCurrentChatInfo';
import { Spiner } from '@/ui-kit';
import { useNavigate, useParams } from 'react-router-dom';
import { routesApp } from '@/constans/routes';
import { useToast } from '@/store/useToast';
import { ErrorNotificationIcon } from '@/assets/icons';
import { useChat } from '@/store/useChat';
import { useTranslation } from 'react-i18next';

export const Chat: React.FC = () => {
    const navigate = useNavigate();
    const { data, isLoading: isLoadingSettings } = useGetSettings();
    const { id } = useParams();

    const showToast = useToast((state) => state.show);
    
    const chatId = Number.isNaN(Number(id)) ? '' : Number(id);
    const {
        data: chatData,
        isLoading: isLoadingChat,
        isError: isErrorChat,
        error: errorChat,
        refetch: refetchMessagesById,
    } = useGetChat(chatId);
    const chatStore = useCurrentChatInfo((state) => state.currentChat);
    const clearCurrentChat = useCurrentChatInfo((state) => state.clearCurrentChat);
    const currentChat = chatData?.data;
    
    const init = useChat(state => state.init)

    const [isChatInit, setChatInit] = useState(false);
    
    useEffect(() => {
        init()
        setChatInit(true)
    }, [])

    const { t } = useTranslation();

    useEffect(() => {
        if (errorChat) {
            const axiosError = errorChat as any;
            if (
                axiosError.response?.status === 403 &&
                axiosError.response?.data?.is_banned
            ) navigate(routesApp.banned);
            else if (
                axiosError
                    .response
                    ?.status === 410 &&
                axiosError
                    .response
                    ?.data
                    ?.deactivated
            ) {
                navigate(routesApp.browse, {
                    replace: true
                })
                showToast({
                    // type error
                    icon: <ErrorNotificationIcon />,
                    msg: t('msgs.no_access_to_chat')
                });
            }
        }
    }, [chatData, errorChat]);

    useEffect(() => clearCurrentChat(), [])

    return (
        <>
            <HeaderChat
                isLoading={isLoadingChat || isErrorChat}
                profileChat={currentChat?.profile ?? chatStore}
                refetchMessages={refetchMessagesById} />
            {isLoadingSettings || isLoadingChat ? (
                <Spiner />
            ) : (
                <ChatViewport
                    key={chatData?.data.pagination?.next}
                    chatId={chatId}
                    profileId={chatData?.data?.profile?.id}
                    profileChat={chatData?.data.profile}
                    chatUrl={data?.data.chat_url}
                    expiredAt={chatData?.data.expired_at}
                    messagesData={chatData?.data.data ? [...chatData?.data.data] : []}
                    paginationData={chatData?.data.pagination}
                    isErrorChat={false}
                    isLoadingChat={false}
                    isChatInit={isChatInit}
                    refetchMessages={refetchMessagesById} />
            )}
        </>
    );
};
